import { FLAME, GREEN, MUTED } from './asesoriaTokens'

export function AsesoriaAudienceSection() {
    return (
        <section className='mx-auto flex max-w-[1200px] flex-col gap-10 px-6 pb-10 pt-20 md:pt-24'>
            <div className='flex max-w-[760px] flex-col gap-4'>
                <div className={`text-xs font-semibold uppercase tracking-[0.14em] ${FLAME}`}>Para quién</div>
                <h2 className='m-0 text-[32px] font-extrabold leading-[1.05] tracking-[-0.03em] md:text-[44px]'>
                    Si tu pasión es el oficio, no la gestión. Y es mejor decirlo ya.
                </h2>
                <p className={`m-0 text-lg ${MUTED}`}>
                    Nosotros nos quedamos con los números y el control del negocio. Tú te quedas con lo que te hace
                    feliz: cocina, sala, producto y cliente.
                </p>
            </div>
            <div className='grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-5'>
                <div className='flex flex-col gap-4 rounded-[20px] border border-[#DDCFB8] bg-[#FAF6EE] p-8'>
                    <h3 className={`m-0 text-[22px] font-bold ${GREEN}`}>Es para ti si</h3>
                    <ul className='m-0 flex list-disc flex-col gap-2.5 pl-5'>
                        <li>Lo que más feliz te hace es aprender más de tu profesión a nivel gastronómico.</li>
                        <li>Odias la gestión y sentarte delante de un ordenador.</li>
                        <li>Vendes más de 40.000 € al mes. Con un local o con varios.</li>
                        <li>Vendes bien pero a final de mes no te cuadra lo que te queda.</li>
                        <li>Decides tú. No hay que convencer a nadie más.</li>
                        <li>
                            Nos das acceso a tu TPV, a tu banco (solo para ver movimientos) y a tu gestoría, y nos
                            enseñas todos tus números, también lo que no pasa por caja.
                        </li>
                        <li>Podemos hablar con quien hace las compras y con quien lleva la sala.</li>
                        <li>Vas a estar en cada reunión y vas a aplicar lo que acordemos.</li>
                    </ul>
                </div>
                <div className='flex flex-col gap-4 rounded-[20px] border border-[#DDCFB8] bg-[#FAF6EE] p-8'>
                    <h3 className={`m-0 text-[22px] font-bold ${FLAME}`}>No es para ti si</h3>
                    <ul className='m-0 flex list-disc flex-col gap-2.5 pl-5'>
                        <li>Tu pasión es la gestión, no el oficio gastronómico.</li>
                        <li>Quieres un informe para leerlo y olvidarte.</li>
                        <li>No puedes dar una hora a la semana.</li>
                        <li>Buscas a alguien que te diga que todo va bien.</li>
                        <li>Quieres resultados sin cambiar nada.</li>
                        <li>Necesitas que te gestionemos la cocina o el servicio día a día.</li>
                    </ul>
                </div>
            </div>
            <div className='flex flex-wrap items-center gap-6 rounded-[20px] border-2 border-[#F4502A] bg-[rgba(244,80,42,0.12)] p-8'>
                <div className={`min-w-0 flex-[1_1_260px] text-xs font-bold uppercase tracking-[0.14em] ${FLAME}`}>
                    Condición
                </div>
                <div className='flex min-w-0 flex-[999_1_480px] flex-col gap-2.5'>
                    <p className='m-0 text-[26px] font-extrabold leading-[1.15] tracking-tight'>
                        Si no vienes a las reuniones o no aplicas lo que acordamos, dejamos de trabajar juntos.
                    </p>
                    <p className={`m-0 ${MUTED}`}>Cobramos una parte de lo que mejores: nos jugamos lo mismo que tú.</p>
                </div>
            </div>
        </section>
    )
}
